var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQualityControl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#D5EBEF"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9.5 10.7-.4.3-.3-.5c-.1 0-.3.1-.4.1-.9 0-1.5-.7-1.5-1.5 0-.9.7-1.6 1.5-1.6.9 0 1.5.7 1.5 1.6 0 .5-.3 1-.7 1.3zM9 9.8c.2-.2.4-.5.4-.8 0-.6-.4-1-1-1s-1 .5-1 1 .3.9.8 1h.3l-.3-.5.4-.2zM13.1 9.9q-.45.6-1.2.6c-.9 0-1.5-.7-1.5-1.5 0-.9.7-1.6 1.5-1.6.5 0 1 .2 1.2.6l-.4.3q-.45-.3-.9-.3c-.5 0-1 .5-1 1 0 .6.4 1 1 1 .3 0 .6-.2.8-.4z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M12.8 5.1c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7 1.7.8 1.7 1.7-.7 1.7-1.7 1.7m0-2.4c-.4 0-.7.3-.7.7s.3.7.7.7.7-.3.7-.7-.3-.7-.7-.7"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M20.8 21.9c-.3 0-.5-.2-.5-.5V4.8c0-.4-.4-.8-.9-.7h-5.2c-.3 0-.5-.2-.5-.5s.3-.6.5-.6h5.1c1 0 1.8.7 1.9 1.7v16.6c.1.3-.1.6-.4.6M6.6 23.1c-.5 0-.9-.2-1.3-.5s-.6-.8-.6-1.3V4.7c0-1 .8-1.8 1.8-1.8h5.1c.3 0 .5.2.5.5s-.2.5-.5.5H6.5c-.5 0-.8.4-.8.8v16.6q0 .3.3.6c.2.1.4.2.6.2h10.9c.3 0 .5.2.5.5s-.2.5-.5.5z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M15.1 21.7c-2.5 0-4.6-2.1-4.6-4.6s2.1-4.6 4.6-4.6 4.6 2.1 4.6 4.6-2 4.6-4.6 4.6m0-8.2c-2 0-3.6 1.6-3.6 3.6s1.6 3.6 3.6 3.6 3.6-1.6 3.6-3.6-1.6-3.6-3.6-3.6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M20.8 24.3c-.1 0-.3-.1-.4-.2l-3.2-3.4c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.4c.2.2.2.5 0 .7-.1.1-.2.2-.3.2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M14.3 19.1c-.2 0-.3-.1-.5-.2l-.8-.6c-.2-.2-.3-.5-.1-.7s.5-.3.7-.1l.7.5 2.2-2.5c.2-.2.5-.2.7 0s.2.5 0 .7l-2.4 2.7c-.1.1-.3.2-.5.2m.2-.9"
})));
export default SvgQualityControl;